import {SubjectActions} from '.'
import { type } from 'os';

let initialState={
    subjectList:[],
    subjectMasterDataList:{},
    getSubjectsInProgress:false,
    getSubjectMasterDataInProgress:false
}

export const subjectReducer = (state = initialState , action) =>{
    switch(action.type){
        case SubjectActions.GET_SUBJECT_MASTER_DATA_IN_PROGRESS:
            return{...state , getSubjectMasterDataInProgress:true }
        
        case SubjectActions.GET_SUBJECT_MASTER_DATA_COMPLETE:
            return{...state , getSubjectMasterDataInProgress:false , subjectMasterDataList:action.data}

        case SubjectActions.SAVE_SUBJECTS_IN_PROGRESS:
            return{...state , saveSubjectsInProgress:true}

        case SubjectActions.SAVE_SUBJECTS_COMPLETE:
            return{...state ,  saveSubjectsInProgress:false , data:action.data}

        case SubjectActions.GET_SUBJECTS_IN_PROGRESS :
             return {...state , getSubjectsInProgress :true};
    
        case SubjectActions.GET_SUBJECTS_COMPLETE :
            return{...state , getSubjectsInProgress :false , subjectList:action.data};

        default :
            return state
    }
}

export default subjectReducer;